import {cs} from "@common/react/chain-services";
import {TextInput} from "../../../../../../../../../common/form/text-input/text-input";
import {ffToTextInput} from "../../../../../../../../../common/form/ff-to-text-input";
import {Form2} from "@common/react/cs-form/form2";
import {consumeContext} from "@common/react/context";
import {ConnectionSettingsLayout} from "../connection-settings-layout";
import {DsFolderField} from "../../../../../common/folders-dialog/ds-folder-field";
const {required} = require("@common/react/cs-form/validators/required");

export const DV360ConnectionForm = ({data, adding, dsApi, connectionStatus, formConfig, next}) =>
    cs(
        consumeContext("apis"),
        [
            "form",
            ({apis}, next) =>
                Form2({
                    data,
                    fields: {
                        ...formConfig,
                        "connectionDetails.partnerId": [required],
                        "connectionDetails.projectId": [required],
                        "connectionDetails.privateKeyId": [required],
                        "connectionDetails.privateKey": [required],
                        "connectionDetails.clientId": [required],
                        "connectionDetails.clientEmail": [required],
                        "connectionDetails.clientCertUrl": [required]
                    },
                    next,
                }),
        ],
        [
            "testConnection",
            ({form}, next) =>
                next(() => {
                    const _connectionDetails = form.data.value?.connectionDetails;
                    const databaseConfigData = {
                        $type: data.value.$type,
                        ..._connectionDetails,
                    };

                    return dsApi.testConnection(
                        {
                            submitConnectionDetails: databaseConfigData,
                            connectionDetails: databaseConfigData,
                        },
                        {
                            type: data.value?.type,
                            name: form.data.value?.name,
                        }
                    );
                }),
        ],
        ({form, testConnection}) => {
            return next({
                valid: form.valid,
                beforeGoNext: testConnection,
                render: () =>
                    ConnectionSettingsLayout({
                        type: data.value.type,
                        adding,
                        connectionStatus,
                        controls: {
                            valid: form.valid,
                            onTestConnection: testConnection,
                            onDiscard: () =>
                                form.data.onChange({
                                    ...data.value,
                                    connectionDetails: {},
                                }),
                            onGoNext: dsApi.onNextStep,
                        },
                        content: (
                            <>
                                {TextInput({
                                    label: "Display Name",
                                    ...ffToTextInput(form.field("name")),
                                })}

                                {DsFolderField({
                                    state: form.field("folderID").state,
                                })}

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Partner ID",
                                        placeholder: "1234567890",
                                        ...ffToTextInput(form.field("connectionDetails.partnerId")),
                                    })}
                                </div>

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Project ID",
                                        placeholder: "yyy-zzz",
                                        ...ffToTextInput(form.field("connectionDetails.projectId")),
                                    })}
                                </div>

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Client ID",
                                        placeholder: "1234567890",
                                        ...ffToTextInput(form.field("connectionDetails.clientId")),
                                    })}
                                </div>

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Client Email",
                                        placeholder: "service-account@service-account.iam.gserviceaccount.com",
                                        ...ffToTextInput(form.field("connectionDetails.clientEmail")),
                                    })}
                                </div>

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Client Cert Url",
                                        placeholder: "https://www.googleapis.com/robot/v1/metadata/x509/",
                                        ...ffToTextInput(form.field("connectionDetails.clientCertUrl")),
                                    })}
                                </div>

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Private Key ID",
                                        placeholder: "04633c12d531eba800",
                                        ...ffToTextInput(form.field("connectionDetails.privateKeyId")),
                                    })}
                                </div>

                                <div className="form-group-flex">
                                    {TextInput({
                                        label: "Private Key",
                                        placeholder: "-----BEGIN PRIVATE KEY-----",
                                        ...ffToTextInput(form.field("connectionDetails.privateKey")),
                                        multiline: true,
                                        rows: 4
                                    })}
                                </div>
                            </>
                        ),
                    }),
            });
        }
    );
